module.exports = __webpack_public_path__ + "static/img/failure.1dba54e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/failure.svg
// module id = tbW+
// module chunks = 1